/**
 * Redirige rutas sin prefijo store (ej. /products/inventory) a /store/:storeSlug/...
 * Para enlaces antiguos o bookmarks.
 * Usa useEffect + useNavigate para evitar "Maximum update depth exceeded" (Navigate en render provoca bucle).
 */
import { useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import { storePath } from '@/config/routes.config';
import { RedirectLoading } from '@/components/RedirectLoading';

export function RedirectToStorePath() {
  const location = useLocation();
  const navigate = useNavigate();
  const { storeSlug, loading, tenantId } = useAuth();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (loading || !tenantId || !storeSlug) return;
    if (didRedirect.current) return;
    const path = location.pathname.startsWith('/') ? location.pathname : `/${location.pathname}`;
    const storePrefix = `/store/${encodeURIComponent(storeSlug)}`;
    // Evitar duplicar /store/slug: si el path ya es /store o /store/..., ir solo al dashboard.
    const isAnyStorePath = path === '/store' || path.startsWith('/store/');
    const alreadyInOurStore = path === storePrefix || path.startsWith(storePrefix + '/');
    const target =
      isAnyStorePath || alreadyInOurStore
        ? storePath(storeSlug, '')
        : storePath(storeSlug, path);
    if (location.pathname === target) return;
    didRedirect.current = true;
    navigate(target, { replace: true });
  }, [loading, tenantId, storeSlug, location.pathname, navigate]);

  if (loading || !tenantId || !storeSlug) return <RedirectLoading />;
  return <RedirectLoading />;
}
